import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

declare var $ : any;
@Component({
  selector: 'app-protection-of-data-modal',
  templateUrl: './protection-of-data-modal.component.html',
  styleUrls: ['./protection-of-data-modal.component.css']
})
export class ProtectionOfDataModalComponent implements OnInit {

  @Output()  deleteConfirmFinished= new EventEmitter<string>()
  loading=false
  errorSaving=false
  isSaving=false
  openOptions=[0,1]
  myForm = new FormGroup({
    txtConfirm: new FormControl(''),

  });
  constructor() { }
    get f(){
      return this.myForm.controls
    }
  ngOnInit(): void {
    this.loading=true
    this.errorSaving=false


  }
  on_submit(){
    this.isSaving=true
    this.closeDelModal()
  }

  closeDelModal(){
    $("#dataProtectionConfirmModal").modal("hide");
    let dd=this.myForm.value.txtConfirm
    this.deleteConfirmFinished.emit(dd)
  }

}
